export default "__VITE_ASSET__B1SmR6uV__"